import React from "react";
import { useSelector } from "react-redux";
import {
  isMGWebView,
  isParkPlusWebView,
  isUCDWebView,
} from "core-lib/utils/source";
import { isServer, isStringValid, uuidGenerator } from "core-lib/utils/utils";
import { useGetProfile } from "auth/hooks/useGetProfile";
import { API_STATUS } from "../../constants/network";
import { Cookies, LocalStorage, SessionStorage } from "../../constants/storage";
import { getCookieValue, setCookieValue } from "../../utils/cookie";
import { getOsVersionFromNavigator } from "../../utils/helpers";
import { getQueryObj } from "core-lib/utils/common";

export function ActivityRecorder() {
  const { isAuthenticated, profile } = useSelector((state) => state.auth);

  const { init: fetchProfile, apiCall: profileCall } = useGetProfile({});

  function setOneTimeData() {
    if (!isServer()) {
      const query = getQueryObj();
      if (
        !sessionStorage.getItem(SessionStorage.InitialPagePath) &&
        !sessionStorage.getItem(SessionStorage.InitialPageFullPath)
      ) {
        const url = new URL(global.window.location.href);
        global.window.sessionStorage.setItem(
          SessionStorage.InitialPagePath,
          url.pathname
        );
        global.window.sessionStorage.setItem(
          SessionStorage.InitialPageFullPath,
          `${url.origin}${url.pathname}`
        );
      }

      // set session id if user is coming first time
      if (!sessionStorage.getItem(SessionStorage.TrackingSessionId)) {
        sessionStorage.setItem(
          SessionStorage.TrackingSessionId,
          uuidGenerator()
        );
      }

      // set anonymous id if user is coming first time
      if (!localStorage.getItem(LocalStorage.SegmentAnonymousId)) {
        localStorage.setItem(LocalStorage.SegmentAnonymousId, uuidGenerator());
      }

      if (!getCookieValue(Cookies.WebviewPlatform)) {
        const os = getOsVersionFromNavigator();
        setCookieValue(Cookies.WebviewPlatform, os);
      }
      const utmSource = query?.utm_source;
      const utmCampaign = query?.utm_campaign;
      const utmContent = query?.utm_content;
      const utmTerm = query?.utm_term;

      if (utmSource) {
        sessionStorage.setItem(SessionStorage.utmSource, utmSource);
      }
      if (utmCampaign) {
        sessionStorage.setItem(SessionStorage.utmCampaign, utmCampaign);
      }
      if (utmContent) {
        sessionStorage.setItem(SessionStorage.utmContent, utmContent);
      }
      if (utmTerm) {
        sessionStorage.setItem(SessionStorage.utmTerm, utmTerm);
      }

      window.onpopstate = (event) => {
        if (event) {
          // @ts-ignore
          window.popStateData = {
            isNavigatedFromLastPage: true,
            targetRoute: event?.path?.[0]?.location?.pathname,
          };
        }
      };
    }
  }
  function checkAndSetCallout() {
    if (
      !isServer() &&
      (isParkPlusWebView() || isMGWebView() || isUCDWebView())
    ) {
      const appRoot = global.document.getElementsByTagName("BODY")[0];
      if (!appRoot.classList.contains("cmn_no_callout"))
        appRoot.classList.add("cmn_no_callout");
    }
  }

  function setPadding() {
    if (!isServer()) {
      let checkCount = 6;
      const paddingTO = setInterval(() => {
        const pTop = getCookieValue("padding_top") ?? "0";
        const pBottom = getCookieValue("padding_bottom") ?? "0";
        document.documentElement.setAttribute(
          "style",
          `--safe-area-top: ${pTop}px; --safe-area-bottom: ${pBottom}px`
        );
        checkCount += 1;
        if (checkCount > 6) {
          clearInterval(paddingTO);
        }
      }, 500);
    }
  }

  React.useEffect(() => {
    setOneTimeData();
    checkAndSetCallout();
    setPadding();
  }, []);

  React.useEffect(() => {
    if (
      isAuthenticated &&
      !isStringValid(String(profile?.id ?? "")) &&
      profileCall.apiStatus === API_STATUS.default
    ) {
      fetchProfile();
    }
  }, [isAuthenticated, profile]);

  return null;
}
